<div>
  <div class="sx-error">
    <div class="sx-topheader__logo sx-login__logo"></div>
    <h2>{{'core.unauthorized.title' | translate}}</h2>
    <p>{{'core.unauthorized.description' | translate}}</p>
    <button class="sx-button sx-button--blue" mat-button routerLink="/login">{{'core.unauthorized.return' | translate}}</button>
  </div>
</div>